import { memo, useMemo, useState } from 'react'
import { Box, Button, Flex } from '@chakra-ui/react'

import { Empty, Loader } from 'components'
import { useNotificationsManager } from 'contexts/NotificationsManager/Provider'
import markAllNotifiationsAsReaded from 'services/calls/notifications/markAllNotifiationsAsReaded'
import NotificationsFilterAsTags from './components/NotificationsFilterAsTags'
import NotificationCardByKind from './components/NotificationCardByKind'

function NotificationContent() {
  const [loadingButton, setLoadingButton] = useState(false)

  const {
    totalNotifications,
    pagination,
    setPagination,
    loadNotifications,
    notifications,
    loadingNotifications,
    loadingMoreNotifications,
  } = useNotificationsManager()

  const showMoreNotificationsButton = useMemo(() => {
    return pagination.limit < totalNotifications
  }, [])

  async function reloadAllNotificationsAsReaded() {
    setLoadingButton(true)
    const response = await markAllNotifiationsAsReaded()
    if (response?.header?.success) {
      await loadNotifications()
    }
    setLoadingButton(false)
  }

  function goToNextPageOnPagination() {
    setPagination({ ...pagination, page: pagination.page + 1 })
  }

  return (
    <Box>
      <Flex p={4} align="center" justify="space-between" gap={2} borderBottomWidth="1px" borderColor="borderColor">
        <NotificationsFilterAsTags />

        <Button isLoading={loadingButton} size="xs" variant="ghost" onClick={reloadAllNotificationsAsReaded}>
          Marcar todas como lidas
        </Button>
      </Flex>

      {loadingNotifications ? (
        <Loader text="Carregando notificações" />
      ) : (
        <Box>
          {notifications.length > 0 ? (
            <Box>
              {notifications.map((notification) => (
                <NotificationCardByKind key={notification.id} notification={notification} />
              ))}
            </Box>
          ) : (
            <Empty illustration="EmptyDrawer" title="Nenhuma notificação encontrada" />
          )}
        </Box>
      )}

      {showMoreNotificationsButton && (
        <Box p={4} borderTopWidth="1px" borderColor="borderColor">
          <Button isLoading={loadingMoreNotifications} size="md" minWidth="100%" colorScheme="gray" onClick={goToNextPageOnPagination}>
            Ver notificações anteriores
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default memo(NotificationContent)
